import { SettingsPlaceholder } from "@/pages/settings/settings-placeholder";

export function BillingSettingsPage() {
  return (
    <SettingsPlaceholder
      title="Billing"
      description="Payment method, invoices, billing address. Deferred to Phase 2 (payment integration)."
    />
  );
}
